import axios from "axios";
import { base_url } from "../../../constants/routes";

export function saveService(service) {
  return axios
    .post(base_url + "/service", service)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
}

export function findAllService() {
  return axios
    .get(base_url + "/service")
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      return [];
    });
}

export function deleteService(query) {
  return axios
    .put(base_url + "/service" + "/" + query._id, { isDeleted: true })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
}
